import { render, staticRenderFns } from "./wiki-robot-bottom.vue?vue&type=template&id=2c142369"
import script from "./wiki-robot-bottom.vue?vue&type=script&lang=js"
export * from "./wiki-robot-bottom.vue?vue&type=script&lang=js"
import style0 from "./wiki-robot-bottom.vue?vue&type=style&index=0&id=2c142369&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports